import * as React from "react";
import { ILocalization } from "bernie-l10n";

export const EstimatedPriceLabel = ({
  l10n,
  className
}: {
  l10n: ILocalization;
  className?: string;
}) => {
  return (
    <div className={`uitk-type-200 all-b-padding-one uitk-type-center ${className}`}>
      {l10n.formatText("hotels.estimatedPriceLabel")}
    </div>
  );
};
